<template>
	<div v-if="show" @click.self="dismissModal()" class="fixed pin z-50 overflow-hidden bg-smoke-lighter flex">
		<div class="relative bg-grey-lightest shadow-modal w-full max-w-md m-auto flex-col flex rounded m-8 overflow-hidden">
			<div class="w-full bg-green-light py-1"></div>
			<div class="px-3">
				<div class="flex py-2 m-2 px-4">
					<div class="flex-2 text-left">
						<p class="text-lg font-extrabold">Skapa PDF</p>
					</div>
					<div class="flex-1">
						<button @click="dismissModal()" class="float-right text-grey hover:text-grey-darker">
							<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
						</button>
					</div>
				</div>

				<div v-if="hideAnalysesChoices" class="h-full max-h-screen-80 overflow-y-scroll mx-6 mb-6 pb-2 pt-3">
					<p class="mb-4 text-lg font-semibold ml-12 text-left">Inga skiften har valts och du kan därför inte välja analysinställningar</p>
					<p class="mb-4 ml-12 text-left">Men det går bra att skriva ut en PDF utan valda skiften</p>
				</div>
				<div v-else class="h-full max-h-screen-80 overflow-y-scroll mx-6 mb-6 pb-2 pt-3">
					<p class="mb-4 text-lg font-semibold ml-12 text-left">Välj vilka analyser som ska skrivas ut</p>

					<div class="flex flex-wrap w-4/5 max-h-screen-50 overflow-y-scroll border rounded-lg p-4 ml-8 bg-white shadow-inner">
						<div v-for="group in printableGroupAnalyses" :key="group.title" class="w-1/2 p-2">
							<p class="mb-2 font-medium text-left" v-text="group.title"></p>
							<div v-if="group.printable">
								<label class="checkbox-container" v-for="type in group.types" :key="type.slug">
									<input :disabled="savingPdf || !type.printable" :class="[ savingPdf || !type.printable ? 'disabled' : '', 'mr-2 mb-2']" :value="type.id" type="checkbox" v-model="selectedAnalyses">
									<span class="checkmark"></span>
									<span class="checkmark-text" v-text="type.title"></span>
								</label>
							</div>
							<div v-else>
								<p class="font-light text-sm text-left" v-text="'Inte analyserad' + (group.types.length > 1 ? 'e' : '')"></p>
							</div>
						</div>
					</div>

					<div class="ml-12 mt-2">
						<div class="w-1/2 p-2">
							<p class="mb-2 font-medium text-left">Analysrubrik</p>
							<label class="checkbox-container">
								<input :disabled="savingPdf" :class="[ savingPdf ? 'disabled' : '', 'mr-2 mb-2']" type="checkbox" v-model="useInterpolationTitle">
								<span class="checkmark"></span>
								<span class="checkmark-text">Hämta rubrik från interpolationsinställning</span>
							</label>
						</div>
					</div>
					
					<div class="ml-12 mt-2">
						<div class="w-1/2 p-2">
							<p class="mb-2 font-medium text-left">Analysblad</p>
							<label class="checkbox-container">
								<input :disabled="savingPdf" :class="[ savingPdf ? 'disabled' : '', 'mr-2 mb-2']" type="checkbox" v-model="printAnalysis">
								<span class="checkmark"></span>
								<span class="checkmark-text">Analysblad</span>
							</label>
						</div>
					</div>
					
					<div class="ml-12 mt-6">
						<p class="text-left font-semibold mb-4">Interpoleringsalgoritm</p>
						<div class="ml-2">
							<div class="relative mb-2 w-3/5">
								<select v-model="interpolationAlgorithm" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
									<option value="1">Traditionell</option> 
									<option value="3">Ny interpolationsteknik</option>
								</select>
								<div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
									<svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
								</div>
							</div>

							<label class="ml-2 checkbox-container">
								<input type="checkbox" v-model="interpolationColorSmoothing">
								<span class="checkmark"></span>
								<span class="checkmark-text">Använd mjuka färgövergångar</span>
							</label>
						</div>
					</div>
					
					<div class="mt-8">
						<p v-if="savingPdf && percentageComplete == 100"> Din PDF kommer snart att laddas ner!</p>
						<div v-if="savingPdf" class="relative bg-grey-light mt-2 rounded w-4/5 m-auto">
							<div :class="[percentageComplete == 100 ? 'rounded' : 'rounded-l', 'bg-green h-6']" :style="'width:' + percentageComplete + '%'">
								<p class="fixed l-50 text-white font-semibold" v-text="percentageComplete + ' %'" style="margin-top:0.2rem"></p>
							</div>
						</div>
					</div>

				</div>
			</div>

			<div class="w-full bg-grey-lightish py-4">
				<div class="float-right mr-4">
					<button v-if="savingPdf" @click="abortInterpolation()" class="ml-6 py-2 px-2 text-sm text-center text-white block bg-grey-dark hover:bg-grey-darker rounded shadow-md font-bold">
						Avbryt
					</button>
					<button v-else @click="retrieveSamples()" :disabled="savingPdf" :class="[ savingPdf ? 'disabled' : '', 'ml-6 py-2 px-2 text-sm text-center text-white block bg-green hover:bg-green-dark rounded shadow-light font-bold']">
						Skapa PDF
					</button>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

import SVGtoPDF from 'svg-to-pdfkit'
require('@/utils/pdfkit')
require('@/utils/blob-stream')
import PrintableTable from '@/utils/printableAnalysisTable';

import { mapGetters } from 'vuex'

export default {

	data() {
		return {
			show: false,
			hideAnalysesChoices: true,
			selectedAnalyses: [],
			chosenAnalyses: [],
			interpolationAlgorithm: 1,
			interpolationColorSmoothing: 0,
			savingPdf: false,
			pagesCompleted: 0,
			anlysesBeforePrint: [],
			printAnalysis: true,
			useInterpolationTitle: false,

			samplesRecieved: 0,
			samples: [],

			pdf: null,
			pdfStream: null,
		}
	},

	computed: {

		...mapGetters({
			pages:				'layout/pages',
			pdfPages:			'layout/pdfPages',
			analysisTypes:		'analysis/types',
			allAnalysisTypes:	'analysis/allTypes',
			groupsWithTypes:	'analysis/groupsWithTypes',
			currentAnalyses:	'layout/currentAnalyses',
			customer: 			'customer/customer',
		}),

		/**
		 * Returns how many pages have been completed in percentages
		 */
		percentageComplete() {
			let totalPages = this.pages.length * this.selectedAnalyses.length
			return +(this.pagesCompleted / totalPages * 100).toFixed(0)
		},
		
		/**
		 * Will return the groups and their types
		 * with a printable attribute on both the groups and
		 * the types.
		 */
		printableGroupAnalyses() {
			let groups = []
			let group = {}
			let type = null

			this.groupsWithTypes.forEach(originalGroup => {
				// Json parse/stringify is used to clone the object.
				group = JSON.parse(JSON.stringify(originalGroup))
				group.printable = false
				group.types = []

				originalGroup.types.forEach(originalType => {
					type = JSON.parse(JSON.stringify(originalType))
					if(this.currentAnalyses[type.slug]) {
						group.printable = true
					}
					type.printable = this.currentAnalyses[type.slug]
					group.types.push(type)
				})

				groups.push(group)
			})

			return groups
		},

		analysisGroups() {
			return [
				{
					title: 'Grundanalys',
					exists: this.currentAnalyses.ph ? true : false
				},
				{
					title: 'Förrådsanalys',
					exists: this.currentAnalyses.p_hcl ? true : false
				},
				{
					title: 'Jordart',
					exists: this.currentAnalyses.lerhalt ? true : false
				},
				{
					title: 'Kadmium',
					exists: this.currentAnalyses.cd_hno3 ? true : false
				},
				{
					title: 'Tungmetall',
					exists: this.currentAnalyses.zn ? true : false
				},
				{
					title: 'Extra interpolationer',
					exists: this.currentAnalyses.magnesiumbehov || this.currentAnalyses.kalk_50_procent_cao || this.currentAnalyses.avkastningsminskning ? true : false
				},
			]
		}
	},

	mounted() {
		bus.$on('open-print-modal', this.openModal)
		bus.$on('close-print-modal', this.dismissModal)
		bus.$on('sending-page-samples', this.recieveSamples)
	},

    beforeDestroy() {
        bus.$off('open-print-modal')
        bus.$off('close-print-modal')
        bus.$off('sending-page-samples')
	},
	
	watch: {
		pdfPages() {
			if(this.pdfPages.length) {
				this.pagesCompleted += 1
			}
			if(this.pdfPages.length == this.pages.length) {
				this.interpolationComplete()
			}
		},

		useInterpolationTitle() {
			this.$store.dispatch("layout/SET_USE_INTERPOLATION_TITLE", {useInterpolationTitle: this.useInterpolationTitle})
		}
	},

	methods: {
		openModal() {
			this.show = true
			document.getElementById("body").className = "overflow-y-hidden";
			bus.$emit('deselect')

			this.selectAnalyses()

			this.hideAnalysesChoices = this.selectedAnalyses.length === 0
		},
		
		dismissModal() {
			if(this.savingPdf) {
				this.abortInterpolation()
			}
			this.show = false
			this.selectedAnalyses = []
			document.getElementById("body").className = "";
		},

		selectAnalyses() {
			if(!this.selectedAnalyses.length) {
				this.selectedAnalyses = this.analysisTypes.filter(analysis => {
					return this.currentAnalyses[analysis.slug]
				}).map(analysis => analysis.id)
			}
		},

		print() {
			this.chosenAnalyses = this.selectedAnalyses.slice()
			if(this.chosenAnalyses.length) {
				this.savingPdf = true
				// The timeout is needed, otherwise the DOM wont update and the loading bar wont be visible at first
				setTimeout(() => { 
					this.analysesBeforePrint = this.pages.map(page => {
						return {
							id: page.id,
							interpolationType: page.interpolationSettings.interpolationType,
							interpolationAlgorithm: page.interpolationSettings.interpolationAlgorithm,
							interpolationColorSmoothing: page.interpolationSettings.interpolationColorSmoothing
						}
					})

					this.chosenAnalyses.sort((a, b) => a - b)

					this.pdf = new PDFDocument({
						autoFirstPage: false,
					})
					this.pdfStream = this.pdf.pipe(blobStream());

					let firstAnalysis = this.chosenAnalyses.shift()
					firstAnalysis = this.analysisTypes.find(type => type.id == firstAnalysis).slug
					
					bus.$emit('generate-pdf', firstAnalysis, this.interpolationAlgorithm, this.interpolationColorSmoothing)
				}, 1);
			} else {
				this.savingPdf = true
				this.pdf = new PDFDocument({
					autoFirstPage: false,
				})
				this.pdfStream = this.pdf.pipe(blobStream());
				bus.$emit('generate-pdf')
			}
		},

		/**
		 * After the pages have finished their interpolations
		 * and exported an image of their page this method will
		 * add each image to a new page each, then the pages are added to the pdf
		 * Will download the pdf when the last interpolation is done
		 */
		async interpolationComplete() {
			// Sorts the array, copies it right now. Maybe should sort it in vuex
			let sortedPages = this.pdfPages.slice().sort((a, b) => a.index - b.index)
			
			sortedPages.forEach(page => {
				if(this.savingPdf) {
					this.addPageToPdf(page)
				}
			});

			this.$store.dispatch("layout/REMOVE_PDF_PAGES")
			
			if(this.chosenAnalyses.length) {
				let nextAnalysis = this.chosenAnalyses.shift()
				nextAnalysis = this.analysisTypes.find(type => type.id == nextAnalysis).slug
				bus.$emit('generate-pdf', nextAnalysis)
			} else if(this.savingPdf) {

				if(this.printAnalysis) {
					let tableSettings = {
						top: 85,
						left: 40,
						cellHeight: 15,
						fontSize: 8,
						columnPadding: 5,
						font: 'Times-Bold'
					};
					let tableAnalyses = this.allAnalysisTypes.filter(analysis => analysis.id !== 0)
					this.pdf = await PrintableTable.createTablePage(this.pdf, this.samples, this.customer, tableSettings, tableAnalyses)
				}

				this.pdf.end();
				this.pdfStream.on('finish', () => {
					let blob = this.pdfStream.toBlob('application/pdf');
					let link = document.createElement('a')
					link.href = window.URL.createObjectURL(blob)
					link.download = 'markkartering.pdf'
					link.click()
				});

				// Wont remove the statusbar for two seconds after the file is complete
				setTimeout(() => {
					this.savingPdf = false
					this.pagesCompleted = 0
				}, 2000);

				this.anlysesBeforePrint.forEach(pageSettings => {
					this.$store.dispatch("layout/SET_PAGE_SETTINGS", pageSettings)
				})

			}
		},

		/**
		 * Send an event that will tell the pages to send their samples
		 */
		retrieveSamples() {
			this.samples = []
			bus.$emit('requesting-samples')
		},

		/**
		 * When all samples from the different pages are combined in one array printing will be possible
		 */
		recieveSamples(samples) {
			this.samplesRecieved += 1
			this.samples = this.samples.concat(samples)

			if(this.samplesRecieved === this.pages.length) {
				//After the samples are retrieved we can begin printing
				this.print()
				this.samplesRecieved = 0
			}

		},

		/**
		 * Will add a single page to the PDF
		 */
		addPageToPdf(pdfPage) {
			let page = this.$store.getters['layout/getPageById'](pdfPage.id)

			this.pdf.addPage({
				size: page.paperType.format,
				layout: page.paperType.orientation
			})
			SVGtoPDF(this.pdf, pdfPage.svg, 0, 0, {preserveAspectRatio: "xMinYMin meet"});
		},

		abortInterpolation() {
			this.savingPdf = false
			bus.$emit('abort-generating-pdf')
			this.$store.dispatch("layout/REMOVE_PDF_PAGES")
			this.chosenAnalyses = []
			this.pdf = null
			this.pagesCompleted = 0
		}
	}
}
</script>